
type VisitInsurerPricingProps = {
    checkInsuranceData: any;
}


const VisitInsurerPricing = ({
    checkInsuranceData
}: VisitInsurerPricingProps) => {

    return(
        <>
            {checkInsuranceData?.issuerVisitPrice && (checkInsuranceData?.issuerVisitPrice?.total !== 0 || checkInsuranceData?.issuerVisitPrice?.insuredAmount !== 0 || checkInsuranceData?.issuerVisitPrice?.orgAmount !== 0) && (
                <div
                    className={'w-100 d-flex flex-column flex-md-row justify-content-around align-items-center rounded rounded-4 py-3 px-4'}>
                    <div className={'d-flex align-items-center'}>
                        <span className={'text-gray-600'}>
                            مبلغ کل:
                        </span>
                        <span className={'fw-bold text-gray-800'}>
                            &ensp; {checkInsuranceData?.issuerVisitPrice?.total || 0}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center'}>
                        <span className={'text-gray-600'}>
                            سهم سازمان:
                        </span>
                        <span className={'fw-bold text-gray-800'}>
                            &ensp; {checkInsuranceData?.issuerVisitPrice?.orgAmount || 0}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center'}>
                        <span className={'text-gray-600'}>
                            پرداختی بیمار:
                        </span>
                        <span className={'fw-bold text-gray-800'}>
                            &ensp; {checkInsuranceData?.issuerVisitPrice?.insuredAmount || 0}
                        </span>
                    </div>
                </div>
            )}
        </>
    )
}


export default VisitInsurerPricing;